<template>
    <v-container container--fluid mobile-responsive>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-toolbar flat dark color="primary">
                    <v-toolbar-title>New Member Registration</v-toolbar-title>
                </v-toolbar>

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlay = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <v-card class="elevation-12">
                    <v-card-text>
                        <p class="title red--text">Use this form to create a new account for the person you are registering.</p>
                        <p class="font-italic">All fields marked * are mandatory.</p>

                        <v-stepper v-model.lazy="regStep" vertical>
                            <v-stepper-step
                                :rules="[() => !errors.any('step1')]"
                                :editable="editablePanel"
                                :complete="regStep > 1"
                                step="1"
                                :color="regStep > 1 ? 'success' : 'primary'"
                            >
                                Account Details
                            </v-stepper-step>

                            <v-stepper-content step="1">
                                <v-form class="overwrite-inputs" data-vv-scope="step1" lazy-validation>
                                    <v-container grid-list-lg>
                                        <v-card color="grey lighten-5" class="pa-sm-3 pa-0 mb-5 elevetation-6">
                                            <v-layout row wrap class="pa-0 py-3">
                                                <v-flex xs12 sm12 md12>
                                                    <v-input prepend-icon="card_membership" class="hide-details" hide-details="auto">Membership Details</v-input>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12 v-if="autoUsername">
                                                    <v-text-field
                                                        prepend-icon="perm_identity"
                                                        label="Username*"
                                                        v-model.lazy.trim="username"
                                                        v-validate="'required|min:6'"
                                                        :error="errors.has('user.username')"
                                                        :error-messages="errors.collect('user.username')"
                                                        name="user.username"
                                                        counter
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12 v-else>
                                                    <p>Username will be generated automatically based on your firstname and lastname then email to you.</p>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field
                                                        prepend-icon="lock"
                                                        label="Password*"
                                                        v-model.lazy.trim="password"
                                                        :append-icon="showpwd ? 'visibility_off' : 'visibility'"
                                                        :type="showpwd ? 'text' : 'password'"
                                                        v-validate="{
                                                            required: true,
                                                            min: 6,
                                                            regex: /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
                                                        }"
                                                        :error="errors.has('user.password')"
                                                        :error-messages="errors.collect('user.password')"
                                                        name="user.password"
                                                        @click:append="showpwd = !showpwd"
                                                        counter
                                                        ref="password"
                                                        autocomplete="new-password"
                                                        persistent-hint
                                                        hint="6 characters minimum"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field
                                                        prepend-icon="lock"
                                                        label="Password Confirmation*"
                                                        v-model.lazy.trim="password_confirmation"
                                                        :append-icon="showpwdConfirmation ? 'visibility_off' : 'visibility'"
                                                        :type="showpwdConfirmation ? 'text' : 'password'"
                                                        v-validate="'required|confirmed:password'"
                                                        :error="errors.has('user.password_confirmation')"
                                                        :error-messages="errors.collect('user.password_confirmation')"
                                                        name="user.password_confirmation"
                                                        @click:append="showpwdConfirmation = !showpwdConfirmation"
                                                        counter
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                        <v-btn color="primary" @click.native="submitStep('step1')" :disabled="errors.any('step1')">Continue</v-btn>
                                        <div v-if="errors.any('step1')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                                    </v-container>
                                </v-form>
                            </v-stepper-content>

                            <v-stepper-step
                                :rules="[() => !errors.any('step2')]"
                                :editable="editablePanel"
                                :complete="regStep > 2"
                                step="2"
                                :color="regStep > 2 ? 'success' : 'primary'"
                            >
                                Personal Details
                            </v-stepper-step>

                            <v-stepper-content step="2">
                                <v-form class="overwrite-inputs" data-vv-scope="step2" lazy-validation>
                                    <v-container grid-list-lg>
                                        <v-card color="grey lighten-5" class="pa-sm-3 pa-0  mb-5 elevetation-6">
                                            <v-layout row wrap class="pa-0 py-3">
                                                <v-flex xs12 sm12 md12>
                                                    <v-input prepend-icon="account_circle" class="hide-details" hide-details="auto">Member Information</v-input>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        prepend-icon="person"
                                                        label="Legal Firstname*"
                                                        v-model.lazy.trim="firstname"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.firstname')"
                                                        :error-messages="errors.collect('user.firstname')"
                                                        name="user.firstname"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        prepend-icon="person"
                                                        label="Preferred First Name*"
                                                        v-model.trim="prefname"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.prefname')"
                                                        :error-messages="errors.collect('user.prefname')"
                                                        name="user.prefname"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        prepend-icon="person"
                                                        label="Legal Middle Name"
                                                        v-model.trim="middlename"
                                                        :error="errors.has('user.middlename')"
                                                        :error-messages="errors.collect('user.middlename')"
                                                        name="user.middlename"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        prepend-icon="person"
                                                        label="Legal Lastname*"
                                                        v-model.lazy.trim="lastname"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.lastname')"
                                                        :error-messages="errors.collect('user.lastname')"
                                                        name="user.lastname"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <input ref="date_limit" name="date_limit" v-model.lazy.trim="dateLimit" type="hidden" />
                                                    <v-menu
                                                        ref="menu"
                                                        v-model.lazy="modalDOB"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        :return-value.sync="dateDOB"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model.lazy.trim="dob"
                                                                label="Date of Birth*"
                                                                prepend-icon="event"
                                                                v-mask="'##/##/####'"
                                                                hint="dd/mm/yyyy"
                                                                persistent-hint
                                                                v-validate="'required|before:date_limit|date_format:dd/MM/yyyy'"
                                                                :error="errors.has('user.dob')"
                                                                :error-messages="errors.collect('user.dob')"
                                                                name="user.dob"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model.lazy="dateDOB" :max="maxDate" @change="save('')" scrollable>
                                                            <v-spacer></v-spacer>
                                                            <v-btn text color="primary" @click="modalDOB = false">Cancel</v-btn>
                                                            <v-btn text color="primary" @click="$refs.menu.save(dateDOB)">OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete
                                                        cache-items
                                                        :items="countries"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="Country of Birth*"
                                                        prepend-icon="public"
                                                        hint="Start typing then select a country"
                                                        persistent-hint
                                                        v-model.trim="countrybirth"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.countrybirth')"
                                                        :error-messages="errors.collect('user.countrybirth')"
                                                        required
                                                        name="user.countrybirth"
                                                        @input="setStateBirth(countrybirth)"
                                                    ></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6 v-if="countrybirth == 'AU'">
                                                    <v-select
                                                        :items="states"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="State of Birth*"
                                                        prepend-icon="location_on"
                                                        v-model.trim="statebirth"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.statebirth')"
                                                        :error-messages="errors.collect('user.statebirth')"
                                                        name="user.statebirth"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select
                                                        :items="selchoices"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="Do you identify as Aboriginal and/or Torres Strait Islander?*"
                                                        prepend-icon="flag"
                                                        v-model.trim="aboriginal"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.aboriginal')"
                                                        :error-messages="errors.collect('user.aboriginal')"
                                                        required
                                                        name="user.aboriginal"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-select
                                                        prepend-icon="perm_identity"
                                                        :items="genders"
                                                        label="Gender*"
                                                        v-model.lazy.trim="gender"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.gender')"
                                                        :error-messages="errors.collect('user.gender')"
                                                        name="user.gender"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-select
                                                        class="select-hint"
                                                        :items="identifygenderchoices"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="How do you identify in terms of gender?*"
                                                        prepend-icon="perm_identity"
                                                        v-model.trim="identifygender"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.identifygender')"
                                                        :error-messages="errors.collect('user.identifygender')"
                                                        required
                                                        hint="Please note that our competition categories currently include male and female divisions. If you have any specific needs or considerations related to gender that we should be aware of to ensure your participation is supported, please contact the Association."
                                                        persistent-hint
                                                        name="user.identifygender"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                        <v-btn color="primary" @click.native="submitStep('step2')" :disabled="errors.any('step2')">Continue</v-btn>
                                        <v-btn color="error" text @click.native="regStep = 1">Back</v-btn>
                                        <div v-if="errors.any('step2')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                                    </v-container>
                                </v-form>
                            </v-stepper-content>

                            <v-stepper-step
                                :rules="[() => !errors.any('step3')]"
                                :editable="editablePanel"
                                :complete="regStep > 3"
                                step="3"
                                :color="regStep > 3 ? 'success' : 'primary'"
                            >
                                Contact Details
                            </v-stepper-step>

                            <v-stepper-content step="3">
                                <v-form class="overwrite-inputs" data-vv-scope="step3" lazy-validation>
                                    <v-container grid-list-lg>
                                        <v-card color="grey lighten-5" class="pa-sm-3 pa-0  mb-5 elevetation-6">
                                            <v-layout row wrap class="pa-0 py-3">
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Email*"
                                                        prepend-icon="email"
                                                        v-model.lazy.trim="email"
                                                        v-validate="'required|email'"
                                                        :error="errors.has('user.email')"
                                                        :error-messages="errors.collect('user.email')"
                                                        name="user.email"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Mobile*"
                                                        prepend-icon="smartphone"
                                                        v-model.lazy.trim="mobile"
                                                        v-mask="'##########'"
                                                        hint="e.g. 0412345678"
                                                        persistent-hint
                                                        v-validate="'required'"
                                                        :error="errors.has('user.mobile')"
                                                        :error-messages="errors.collect('user.mobile')"
                                                        name="user.mobile"
                                                        maxlength="10"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Home Phone"
                                                        prepend-icon="phone"
                                                        v-model.lazy.trim="phone"
                                                        :error="errors.has('user.phone')"
                                                        :error-messages="errors.collect('user.phone')"
                                                        name="user.phone"
                                                        hint="e.g. 0212345678"
                                                        persistent-hint
                                                        maxlength="10"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Workphone"
                                                        prepend-icon="work"
                                                        v-model.lazy.trim="workphone"
                                                        :error="errors.has('user.workphone')"
                                                        :error-messages="errors.collect('user.workphone')"
                                                        name="user.workphone"
                                                        hint="e.g. 0212345678"
                                                        persistent-hint
                                                        maxlength="10"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap class="pa-0 py-3" v-if="gmap_activated">
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        placeholder="Start typing here to autocomplete your address"
                                                        prepend-icon="location_city"
                                                        id="member_address"
                                                        outlined
                                                        dense
                                                        filled
                                                        hide-details
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap class="pa-2">
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Address*"
                                                        prepend-icon="location_city"
                                                        v-model.lazy.trim="address"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.address')"
                                                        :error-messages="errors.collect('user.address')"
                                                        name="user.address"
                                                        required
                                                        id="member_input"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete
                                                        cache-items
                                                        :items="localities"
                                                        persistent-hint
                                                        hint="Type 2 or more characters"
                                                        label="Suburb*"
                                                        prepend-icon="location_city"
                                                        v-model.lazy="suburb"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.suburb')"
                                                        :error-messages="errors.collect('user.suburb')"
                                                        name="user.suburb"
                                                        @change="setLocation(suburb)"
                                                        required
                                                    ></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Postcode*"
                                                        prepend-icon="location_on"
                                                        v-model.lazy.trim="postcode"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.postcode')"
                                                        :error-messages="errors.collect('user.postcode')"
                                                        name="user.postcode"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-select
                                                        cache-items
                                                        :items="states"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="State*"
                                                        prepend-icon="location_on"
                                                        v-model.lazy.trim="state"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.state')"
                                                        :error-messages="errors.collect('user.state')"
                                                        name="user.state"
                                                        required
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap class="pa-0 py-3">
                                                <v-flex xs12 sm12 md12>
                                                    <v-input prepend-icon="local_hospital" class="input-with-icon" :messages="['Enter medical/allergy information']">Medical Information</v-input>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select
                                                        :items="selchoices"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="Do you have a physical, intellectual or a non-visible (hidden) disability?*"
                                                        prepend-icon="accessible"
                                                        v-model.trim="disability"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.disability')"
                                                        :error-messages="errors.collect('user.disability')"
                                                        required
                                                        @input="setDisabilityType(disability)"
                                                        name="user.disability"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12 v-if="disability == 'yes'">
                                                    <v-select
                                                        :items="disabilitytypechoices"
                                                        item-text="text"
                                                        item-value="value"
                                                        label="Please indicate type of impairment."
                                                        prepend-icon="accessible"
                                                        v-model.trim="disabilitytype"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.disabilitytype')"
                                                        :error-messages="errors.collect('user.disabilitytype')"
                                                        required
                                                        name="user.disabilitytype"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-textarea
                                                        outlined
                                                        prepend-icon="local_hospital"
                                                        v-model.trim="ec_medical"
                                                        auto-grow
                                                        label="Medical Condition(s)"
                                                        :error="errors.has('user.ec_medical')"
                                                        :error-messages="errors.collect('user.ec_medical')"
                                                        name="user.ec_medical"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap class="pa-0 py-3">
                                                <v-flex xs12 sm12 md12>
                                                    <v-input prepend-icon="contact_phone" class="input-with-icon" :messages="['Enter emergency contact(s) information']">Emergency Contact(s)</v-input>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Contact Fullname*"
                                                        prepend-icon="person"
                                                        v-model.lazy.trim="ec_fullname"
                                                        v-validate="'required'"
                                                        :error="errors.has('user.ec_fullname')"
                                                        :error-messages="errors.collect('user.ec_fullname')"
                                                        name="user.ec_fullname"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field
                                                        label="Contact Mobile*"
                                                        prepend-icon="phone"
                                                        v-model.lazy.trim="ec_mobile"
                                                        v-mask="'##########'"
                                                        hint="e.g. 0412345678"
                                                        persistent-hint
                                                        v-validate="'required'"
                                                        :error="errors.has('user.ec_mobile')"
                                                        :error-messages="errors.collect('user.ec_mobile')"
                                                        name="user.ec_mobile"
                                                        maxlength="10"
                                                        required
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                        <v-btn color="primary" @click.native="submitStep('step3')" :disabled="errors.any('step3')">Continue</v-btn>
                                        <v-btn color="error" text @click.native="regStep = 2">Back</v-btn>
                                        <div v-if="errors.any('step3')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                                    </v-container>
                                </v-form>
                            </v-stepper-content>

                            <v-stepper-step :rules="[() => !errors.any('step4')]" :editable="editablePanel" step="4">
                                Privacy / TC's
                            </v-stepper-step>

                            <v-stepper-content step="4">
                                <v-form class="overwrite-inputs" data-vv-scope="step4" lazy-validation>
                                    <v-container grid-list-lg>
                                        <v-card color="grey lighten-5" class="pa-3 mb-5 elevetation-6">
                                            <v-container grid-list-lg>
                                                <v-layout row wrap class="pa-0 py-3">
                                                    <v-flex xs12 sm12 md12>
                                                        <v-input prepend-icon="gavel" class="hide-details" hide-details="auto">Terms & Conditions</v-input>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12 v-if="isAdult">
                                                        <v-expansion-panels dark :value="0">
                                                            <v-expansion-panel class="primary white--text">
                                                                <v-expansion-panel-header
                                                                    ><v-icon left style="line-height: 18px;flex: initial;">error</v-icon>Terms & Conditions</v-expansion-panel-header
                                                                >
                                                                <v-expansion-panel-content class="primary white--text">
                                                                    <v-card light>
                                                                        <v-card-text>
                                                                            <v-alert :value="true" icon="priority_high" outlined>
                                                                                <p>
                                                                                    By ticking this box, you declare that you have read, understood, acknowledge and agree to the
                                                                                    <a
                                                                                        href="https://australia.basketball/wp-content/uploads/2019/09/The-Basketball-Network-Participant-Terms-and-Conditions.pdf"
                                                                                        target="_blank"
                                                                                        >Basketball Network Participant Terms and Conditions</a
                                                                                    >
                                                                                    and
                                                                                    <a href="https://australia.basketball/integrity/" target="_blank"
                                                                                        >Basketball Australia National Integrity Framework</a
                                                                                    >, including the exclusion of implied terms, warning, assumption of risk, release and indemnity. In
                                                                                    addition, you agree that you will be bound by {{ appNameUrls.assoc_name }} constitution and any
                                                                                    regulations and policies (including competition rules or by-laws) made under it.
                                                                                    <a href="/about/policy-procedures/" target="_blank">Click here</a> to view
                                                                                    {{ appNameUrls.assoc_name }} Competition By-Laws, policies and procedures.
                                                                                </p>
                                                                            </v-alert>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12 v-if="!isAdult">
                                                        <v-expansion-panels dark :value="0">
                                                            <v-expansion-panel class="primary white--text">
                                                                <v-expansion-panel-header
                                                                    ><v-icon left style="line-height: 18px;flex: initial;">error</v-icon>Where the applicant is under 18 years of age
                                                                    the below box must be ticked by the applicant’s parent or legal guardian.</v-expansion-panel-header
                                                                >
                                                                <v-expansion-panel-content class="primary white--text">
                                                                    <v-card light>
                                                                        <v-card-text>
                                                                            <v-alert :value="true" icon="priority_high" outlined>
                                                                                <p>
                                                                                    You are the parent or guardian of the applicant. By ticking this box you authorise and consent to
                                                                                    the applicant registering as a Participant and member and participating in the Basketball
                                                                                    Activities. In consideration of the Participant's registration being accepted, you expressly agree
                                                                                    to be responsible for the Participant's behaviour and agree to accept in your capacity as parent or
                                                                                    guardian the
                                                                                    <a
                                                                                        href="https://australia.basketball/wp-content/uploads/2019/09/The-Basketball-Network-Participant-Terms-and-Conditions.pdf"
                                                                                        target="_blank"
                                                                                        >Basketball Network Participant Terms and Conditions</a
                                                                                    >
                                                                                    and
                                                                                    <a href="https://australia.basketball/integrity/" target="_blank"
                                                                                        >Basketball Australia National Integrity Framework</a
                                                                                    >, including the exclusion of implied terms, warning, assumption of risk, release and indemnity. In
                                                                                    addition, you agree that you and your son/daughter will be bound by
                                                                                    {{ appNameUrls.assoc_name }} constitution and any regulations and policies (including competition
                                                                                    rules or by-laws) made under it.
                                                                                    <a href="/about/policy-procedures/" target="_blank">Click here</a> to view
                                                                                    {{ appNameUrls.assoc_name }} Competition By-Laws, policies and procedures.
                                                                                </p>
                                                                            </v-alert>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-expansion-panel-content>
                                                            </v-expansion-panel>
                                                        </v-expansion-panels>
                                                    </v-flex>
                                                    <!-- <v-flex xs12 sm12 md12>
                                                        <v-checkbox class="mt-1 d-inline-block" v-model.lazy.trim="agreed_to_indemnity" v-validate="'required:true'" :error="errors.has('user.agreed_to_indemnity')" :error-messages="errors.collect('user.agreed_to_indemnity')" name="user.agreed_to_indemnity" required>
                                                            <template v-slot:label>
                                                                <div>I agree to</div>
                                                            </template>
                                                        </v-checkbox> <a class="link-policy" target="_blank" href="/about/policy-procedures/">Applicant’s parent or legal guardian Terms & Conditions*</a>
                                                    </v-flex> -->
                                                    <v-flex xs12 sm12 md12>
                                                        <v-checkbox
                                                            class="mt-1 d-inline-block"
                                                            v-model.lazy.trim="agreed_to_terms"
                                                            v-validate="'required:true'"
                                                            :error="errors.has('user.agreed_to_terms')"
                                                            :error-messages="errors.collect('user.agreed_to_terms')"
                                                            name="user.agreed_to_terms"
                                                            required
                                                        >
                                                            <template v-slot:label>
                                                                <div>I agree <span v-cloak v-if="!isAdult">on behalf of the applicant</span>&nbsp;to&nbsp;</div>
                                                            </template>
                                                        </v-checkbox>
                                                        <a class="link-policy" target="_blank" href="/about/policy-procedures/">Registration Terms & Conditions*</a>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-checkbox
                                                            class="mt-1 d-inline-block"
                                                            v-model.lazy.trim="agreed_to_privacy"
                                                            v-validate="'required:true'"
                                                            :error="errors.has('user.agreed_to_privacy')"
                                                            :error-messages="errors.collect('user.agreed_to_privacy')"
                                                            name="user.agreed_to_privacy"
                                                            required
                                                        >
                                                            <template v-slot:label>
                                                                <div>I agree <span v-cloak v-if="!isAdult">on behalf of the applicant</span>&nbsp;to&nbsp;</div>
                                                            </template>
                                                        </v-checkbox>
                                                        <a class="link-policy" target="_blank" href="/about/policy-procedures/"
                                                            >{{ appNameUrls.assoc_name }} Policy and Procedures, Competition and Tribunal By-Laws*</a
                                                        >
                                                    </v-flex>
                                                    <v-flex xs12 class="mt-4" v-if="authErrors.any()">
                                                        <span class="red--text font-weight-bold">Errors:</span><br />
                                                        <small class="red--text" v-html="authErrors.all()"></small>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card>
                                        <v-btn :loading="loginLoading" @click.native="register('step4')" :disabled="errors.any('step4') || loadingReg" color="primary" class="text-left"
                                            >Register<v-icon right>input</v-icon></v-btn
                                        >
                                        <v-btn color="error" text @click.native="regStep = 3">Back</v-btn>
                                        <!-- <div v-if="errors.any('step8')" class="red--text text--lighten-1">Please check the form above for errors.</div> -->
                                    </v-container>
                                </v-form>
                            </v-stepper-content>
                        </v-stepper>
                        <v-alert class="mt-4" v-model.lazy.trim="alert" outlined transition="scale-transition" dismissible type="error"
                            >Error! Please check all steps above for errors</v-alert
                        >
                    </v-card-text>
                    <v-divider light></v-divider>
                    <v-card-text>
                        <div class="text-center pt-2"><span color="gray--text">Already have an account?</span> <router-link :to="{ name: 'login' }">Login</router-link></div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import moment from "moment";

export default {
    $_veeValidate: {
        validator: "new",
    },
    data() {
        return {
            action: "register",
            regStep: 1,
            loadingReg: false,

            username: null,
            firstname: null,
            lastname: null,
            dob: null,
            gender: null,
            genders: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }],
            email: null,
            mobile: null,
            ec_fullname: null,
            ec_mobile: null,
            phone: null,
            workphone: null,
            address: null,
            suburb: null,
            postcode: null,
            state: "NSW",
            password: null,
            password_confirmation: null,
            showpwd: false,
            showpwdConfirmation: false,
            agreed_to_terms: false,
            agreed_to_privacy: false,
            agreed_to_indemnity: false,
            np: true,

            search: null,
            // localities: [],
            // locSubs: [],

            modalDOB: false,
            dateDOB: null,
            maxDate: moment().format("YYYY-MM-DD"),
            dateLimit: moment().format("DD/MM/YYYY"),

            selchoices: [{ text: "Yes", value: "yes" }, { text: "No", value: "no" }, { text: "Prefer not to say", value: "notsay" }],
            identifygenderchoices: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }, { text: "Non-binary", value: "non-binary" }],
            disabilitytypechoices: [{ text: "Physical Impairment", value: "physical" }, { text: "Intellectual / Learning Impairment", value: "intellectual" }, { text: "Neurological Impairment", value: "neurological" }, { text: "Sensory and/or Speech Impairment", value: "sensory" }, { text: "Other", value: "other" }],
            disability:'',
            disabilitytype: '',
            identifygender: '',
            countrybirth: '',
            statebirth: '',
            aboriginal: '',
            middlename: '',
            prefname: '',
            gmap_activated: window.LMP.lmpGmap.activated,
            ec_medical: "",

            alert: false,
            editablePanel: false,
            overlayColor: "cyan darken-2",
            overlay: false,
            overlayText: "",
            timeout: 500,

            dictionary: {
                messages: {
                    required: () => "This field is required",
                    email: () => "This field must be a valid email",
                    date_format: () => "This field must be a valid date",
                    numeric: () => "This field is number only",
                    min: (f, v) => "This field must be at least " + v + " characters",
                    confirmed: (f, v) => "This field confirmation does not match " + v,
                    regex: () => "This field must contain at least 1 uppercase letter, 1 lowercase letter and 1 numeric character",
                    before: () => "Date must be before today's date",
                },
            },
        };
    },
    computed: {
        isAdult() {
            return moment(this.dob, "DD-MM-YYYY").isBefore(moment().subtract(18, "years"));
        },
        lengthPassword() {
            return lmpSettings.setting_length_password;
        },
        authErrors() {
            return this.$store.getters["auth/authErrors"];
        },
        loginLoading() {
            return this.$store.getters["auth/authStatus"] == "loading";
        },
        autoUsername() {
            return !lmpSettings.setting_auto_username;
        },
        states() {
            return this.$store.getters["common/getData"]("states");
        },
        countries() {
            return this.$store.getters["common/getData"]("countries");
        },
        localities() {
            return this.$store.getters["common/getData"]("localities");
        },
    },
    watch: {
        // search (val) {
        //     if (!this.localities.length > 0) {
        //         this.$store.dispatch('common/dataRequest', {type: 'localities'}).then(() => {
        //             this.localities = this.$store.getters['common/getData']('localities');
        //         });
        //     }
        //     if(val && val.length >= 3){
        //         this.locSubs = this.localities.filter(locality => {
        //             if(locality.text.toLowerCase().includes(val.toLowerCase()) > -1){
        //                 return true;
        //             }
        //         });
        //     } else {
        //         this.locSubs = [];
        //     }
        // }
    },
    methods: {
        updateProfileAddress(){
            let place = this.autocomplete.getPlace();

            if (place) {
                let address1 = place.formatted_address.split(', ');
                this.address = address1[0];

                for (const component of place.address_components) {
                    const componentType = component.types[0];

                    switch (componentType) {
                        case "postal_code": {
                            this.postcode = component.long_name;
                            break;
                        }
                        case "locality": {
                            this.suburb = component.long_name.toUpperCase();
                            break;
                        }
                        case "administrative_area_level_1": {
                            this.state = component.short_name;
                            break;
                        }
                    }
                }

                setTimeout(() => {
                    document.getElementById('member_address').value = '';
                }, 100);
                setTimeout(() => {
                    document.getElementById('member_address').value = '';
                }, 100);

                document.getElementById('member_input').focus();
            }
        },
        initLocationSearch() {
            this.autocomplete = new window.google.maps.places.Autocomplete(
                document.getElementById('member_address'), {
                    componentRestrictions: { country: ["au"] },
                    fields: ["address_components", "formatted_address"],
                    types: ["address"],
                }
            );

            this.autocomplete.addListener("place_changed", this.updateProfileAddress);
        },
        submitStep(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.regStep++;
                    if (this.regStep == 4) {
                        this.editablePanel = true;
                    }
                }
            });
        },
        save() {
            this.modalDOB = false;
            this.dob = this.dateDOB ? moment(this.dateDOB).format("DD/MM/YYYY") : "";
        },
        register: function(scope) {
            this.loadingReg = true;
            this.alert = false;
            this.$validator.validateAll("step1").then(result => {
                if (result) {
                    this.$validator.validateAll("step2").then(result => {
                        if (result) {
                            this.$validator.validateAll("step3").then(result => {
                                if (result) {
                                    this.$validator.validateAll("step4").then(result => {
                                        if (result) {
                                            this.agreed_to_indemnity = this.agreed_to_privacy;
                                            const {
                                                action,
                                                username,
                                                firstname,
                                                lastname,
                                                dob,
                                                gender,
                                                email,
                                                mobile,
                                                phone,
                                                workphone,
                                                address,
                                                suburb,
                                                state,
                                                postcode,
                                                password,
                                                password_confirmation,
                                                agreed_to_terms,
                                                agreed_to_privacy,
                                                agreed_to_indemnity,
                                                np,
                                                ec_fullname,
                                                ec_mobile,

                                                middlename,
                                                prefname,
                                                disability,
                                                disabilitytype,
                                                identifygender,
                                                countrybirth,
                                                statebirth,
                                                aboriginal,
                                                ec_medical
                                            } = this;
                                            this.$store
                                                .dispatch("auth/authRequest", {
                                                    action,
                                                    username,
                                                    firstname,
                                                    lastname,
                                                    dob,
                                                    gender,
                                                    email,
                                                    mobile,
                                                    phone,
                                                    workphone,
                                                    address,
                                                    suburb,
                                                    state,
                                                    postcode,
                                                    password,
                                                    password_confirmation,
                                                    agreed_to_terms,
                                                    agreed_to_privacy,
                                                    agreed_to_indemnity,
                                                    np,
                                                    ec_fullname,
                                                    ec_mobile,

                                                    middlename,
                                                    prefname,
                                                    disability,
                                                    disabilitytype,
                                                    identifygender,
                                                    countrybirth,
                                                    statebirth,
                                                    aboriginal,
                                                    ec_medical,

                                                    'sport': 'basketball'
                                                })
                                                .then(() => {
                                                    this.overlayText = "Member created successful.";
                                                    this.overlay = true;
                                                    this.overlayColor = "primary";

                                                    setTimeout(() => {
                                                        this.$router.push({ name: "dashboard" });
                                                    }, this.timeout);
                                                })
                                                .catch(err => {
                                                    this.alert = true;
                                                    this.loadingReg = false;

                                                    // console.log(err);

                                                    if (err.status == 409) {
                                                        this.overlay = true;
                                                        this.overlayText = this.authErrors.get("conflict");
                                                        setTimeout(() => {
                                                            this.overlay = false;
                                                        }, this.timeout);
                                                    }
                                                });
                                        } else {
                                            this.alert = true;
                                            this.loadingReg = false;
                                        }
                                    });
                                } else {
                                    this.alert = true;
                                    this.loadingReg = false;
                                }
                            });
                        } else {
                            this.alert = true;
                            this.loadingReg = false;
                        }
                    });
                } else {
                    this.alert = true;
                    this.loadingReg = false;
                }
            });
        },
        setLocation(suburb) {
            if (suburb) {
                let locality = [];

                locality = this.localities.filter(function(object) {
                    return object.value == suburb;
                })[0];

                this.postcode = locality.postcode;
                this.state = locality.state;
            }
        },
        setStateBirth(country) {
            if (country != 'AU') {
                this.statebirth = '';
            }
        },
        setDisabilityType(disability) {
            if (disability != 'yes') {
                this.disabilitytype = '';
            }
        },
    },
    mounted() {
        this.$validator.localize("en", this.dictionary);

        if(window.LMP.lmpGmap.activated){
            window.checkAndAttachMapScript(this.initLocationSearch);
        }
    },
    created() {
        this.$store.dispatch("common/dataRequest", { type: "localities" });
        this.$store.dispatch("common/dataRequest", { type: "states" });
        this.$store.dispatch("common/dataRequest", { type: "countries" });
    },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
    .mobile-responsive .v-stepper--vertical .v-stepper__step {
        padding: 10px;
    }
    .mobile-responsive .v-stepper--vertical .v-stepper__content {
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
    }
    .mob-block {
        width: 100% !important;
    }
}

[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.v-alert .v-alert__icon.v-icon {
    align-self: flex-start;
}

.v-input--checkbox .v-label {
    height: auto !important;
}

.link-policy {
    vertical-align: super;
    font-weight: normal;
    font-family: Roboto, sans-serif;
    font-size: 16px;
}

.v-input.input-with-icon .v-input__prepend-outer {
    margin-top: 0;
}

.v-input.input-with-icon .v-input__control .v-input__slot {
    // margin-bottom: 0;
    // margin-top: 2px;
}

.v-input.hide-details.v-input--hide-details {
    align-items: center;
}

.select-hint .v-text-field__details .v-messages__message {
    font-size: 10px !important;
    color: #d3473c !important;
}
</style>
